import { render } from "./ItemWrap.vue?vue&type=template&id=65cbac6c&ts=true"
import script from "./ItemWrap.vue?vue&type=script&lang=ts"
export * from "./ItemWrap.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__